<nb-select fullWidth
           [(selected)]="value"
           [placeholder]="'Status auswählen'"
           [disabled]="isDisabled">
  <nb-option [value]="null">Alle</nb-option>
  <nb-option [value]="true">Überholt</nb-option>
  <nb-option [value]="false">Aktuell</nb-option>
</nb-select>
